var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreBenefitsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10H10C8.67392 10 7.40215 10.5268 6.46447 11.4645C5.52678 12.4021 5 13.6739 5 15V50C5 51.3261 5.52678 52.5979 6.46447 53.5355C7.40215 54.4732 8.67392 55 10 55H45C46.3261 55 47.5979 54.4732 48.5355 53.5355C49.4732 52.5979 50 51.3261 50 50V32.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 6.25008C47.2446 5.25552 48.5935 4.69678 50 4.69678C51.4065 4.69678 52.7554 5.25552 53.75 6.25008C54.7446 7.24464 55.3033 8.59355 55.3033 10.0001C55.3033 11.4066 54.7446 12.7555 53.75 13.7501L30 37.5001L20 40.0001L22.5 30.0001L46.25 6.25008Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsEdit);
export default __webpack_public_path__ + "static/media/core-benefits-edit.d6a36f2ac2f4cb8cfc72eec80c90f038.svg";
export { ForwardRef as ReactComponent };